import { render, staticRenderFns } from "./AssignOrdersDeliveryRider.vue?vue&type=template&id=0513aaa4&scoped=true&"
import script from "./AssignOrdersDeliveryRider.vue?vue&type=script&lang=js&"
export * from "./AssignOrdersDeliveryRider.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrdersDeliveryRider.vue?vue&type=style&index=0&id=0513aaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513aaa4",
  null
  
)

export default component.exports